import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils"

/**
 * Мелкая метка (способ входа, роль, язык). Для статусов — <StatusPill> из components/app:
 * у него тон (pos/warn/neg/neutral/info) и он всегда с текстом.
 */
const badgeVariants = cva(
  "inline-flex h-[22px] items-center gap-1 whitespace-nowrap rounded-[7px] px-2 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "bg-accent text-on-accent",
        secondary: "bg-muted text-text",
        destructive: "bg-neg-soft text-neg",
        outline: "border border-border text-text",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({
  className,
  variant,
  ...props
}: BadgeProps) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
